export { default } from "./RuleModal";
